import React from 'react';
import { Box, Typography, Stack } from '@mui/material';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';

const PageContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  height: 'calc(100vh - 100px)',
  maxHeight: 'calc(100vh - 100px)',
  backgroundColor: theme.palette.background.default,
  overflow: 'hidden',
  position: 'relative',
}));

const HeaderSection = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: theme.spacing(1, 2, 0.5, 2),
  backgroundColor: 'transparent',
  flexShrink: 0,
}));

const ContentSection = styled(Box)(({ theme }) => ({
  flexGrow: 1,
  minHeight: 0,
  display: 'flex',
  flexDirection: 'column',
  padding: theme.spacing(0.5, 1, 0, 1),
  overflow: 'hidden',
  position: 'relative',
}));

const EasyCheckPageContainer = ({ children, ...props }) => (
  <PageContainer {...props}>
    {children}
  </PageContainer>
);

const EasyCheckPageHeader = ({ 
  title, 
  subtitle, 
  actions, 
  leftContent,
  ...props 
}) => (
  <HeaderSection {...props}>
    <Box>
      {leftContent || (
        <Box>
          <Typography variant="h4" fontWeight={700} color="primary">
            {title}
          </Typography>
          {subtitle && (
            <Typography variant="body1" color="text.secondary" sx={{ mt: 0.5 }}>
              {subtitle}
            </Typography>
          )}
        </Box>
      )}
    </Box>
    {actions && (
      <Stack direction="row" spacing={2}>
        {actions}
      </Stack>
    )}
  </HeaderSection>
);

const EasyCheckPageContent = ({ children, ...props }) => (
  <ContentSection {...props}>
    {children}
  </ContentSection>
);

EasyCheckPageContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

EasyCheckPageHeader.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  actions: PropTypes.node,
  leftContent: PropTypes.node,
};

EasyCheckPageContent.propTypes = {
  children: PropTypes.node.isRequired,
};

export {
  EasyCheckPageContainer,
  EasyCheckPageHeader,
  EasyCheckPageContent
}; 